<!-- partners -->
<div class="section section-partners height-auto">

  <div class="container-fluid">

    <div class="container-section">

      <!-- desktop slider -->
      <div class="d-none d-sm-block slider-partners">
        <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="false" *ngIf="partnerSlider.slides_desktop">
          <ng-template *ngFor="let slide of partnerSlider.slides_desktop" ngbSlide>

            <div class="row">

              <div class="col-2" *ngFor="let slideItem of slide">
                <div class="item-wrapper text-center">
                  <div class="img-wrapper">
                    <a class="link" [href]="slideItem.url" target="_blank">
                      <img class="img-fluid image filter-grayscale filter-grayscale-hover-color" [src]="slideItem['image_url']" [attr.alt]="slideItem['title']">
                    </a>
                  </div>
                </div>
              </div>

            </div>

          </ng-template>
        </ngb-carousel>
      </div>

      <!-- mobile slider -->
      <div class="d-block d-sm-none slider-partners">
        <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="false" *ngIf="partnerSlider.slides_mobile">
          <ng-template *ngFor="let slide of partnerSlider.slides_mobile" ngbSlide>

            <div class="row">

              <div class="col-6" *ngFor="let slideItem of slide">
                <div class="item-wrapper">
                  <div class="img-wrapper">
                    <a class="link" [href]="slideItem.url" target="_blank">
                      <img class="img-fluid image filter-grayscale filter-grayscale-hover-color" [src]="slideItem['image_url']" [attr.alt]="slideItem['title']">
                    </a>
                  </div>
                </div>
              </div>

            </div>

          </ng-template>
        </ngb-carousel>

      </div>

      <div class="row row-button-more">
        <div class="col-12 text-center">
          <a routerLink="our-network" class="btn btn-primary btn-special">
            {{'View all companies' | translate}}
          </a>
        </div>
      </div>

    </div>

  </div>

</div>
